export default __webpack_public_path__ + "static/media/12_tag_convenience-store.111ae361.svg";